export default __webpack_public_path__ + "static/media/exploded-view_thumbnail.212113e9.png";